export const PersonWithSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={170} height={166} fill="none">
    <path
      fill="#0038FF"
      d="M160.25 40.344c-9.084-13.79-26.349-21.979-43.038-20.412-16.689 1.566-32.05 12.816-38.29 28.044-3.188 7.778-4.2 16.505-8.97 23.466-4.89 7.136-13.035 11.393-21.028 14.948-7.994 3.555-16.386 6.83-22.691 12.81s-10.022 15.568-6.292 23.346c3.791 7.906 13.367 11.063 20.28 16.584 6.913 5.521 11.313 13.639 18.375 18.975 6.525 4.929 14.934 7.101 23.177 7.084 8.242-.016 16.36-2.095 24.061-4.969 23.893-8.916 46.402-25.51 55.933-48.732 17.653-43.008-1.517-71.144-1.517-71.144Z"
    />
    <path
      fill="#fff"
      d="M160.25 40.344c-9.084-13.79-26.349-21.979-43.038-20.412-16.689 1.566-32.05 12.816-38.29 28.044-3.188 7.778-4.2 16.505-8.97 23.466-4.89 7.136-13.035 11.393-21.028 14.948-7.994 3.555-16.386 6.83-22.691 12.81s-10.022 15.568-6.292 23.346c3.791 7.906 13.367 11.063 20.28 16.584 6.913 5.521 11.313 13.639 18.375 18.975 6.525 4.929 14.934 7.101 23.177 7.084 8.242-.016 16.36-2.095 24.061-4.969 23.893-8.916 46.402-25.51 55.933-48.732 17.653-43.008-1.517-71.144-1.517-71.144Z"
      opacity={0.7}
    />
    <path
      fill="#0038FF"
      d="M128.154 148.555s5.799-.031 12.23-8.995c5.621-7.834-5.046-32.094-11.027-37.674-5.981-5.58-17.622 24.896-16.27 32.617 1.926 10.999 10.216 13.77 15.067 14.052Z"
    />
    <path
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m137.564 133.482-8.928 8.876.9 22.616h-2.94c-.036-.156.076-15.736.172-33.908l-6.844-6.564c.52 0-.412-.888-.504-.976l7.364 5.124c.06-11.356.116-20.5.116-20.5l.668-.836.372 12.144 6.312-4.544c-.092.088-1.024.976-.504.976l-5.744 5.712.536 17.496 9.744-7.012c-.132.124-1.468 1.396-.72 1.396Z"
    />
    <path
      fill="#0038FF"
      d="M154.69 155.919s7.053-.508 10.574-7.209c3.801-7.236-5.468-24.391-10.203-25.672-5.185-1.403-13.41 12.312-11.728 22.97 1.149 7.278 8.095 9.726 11.357 9.911Z"
    />
    <path
      stroke="#222"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="m159.984 142.798-4.919 3.91-.279-16.508-.625-.685-.225 9.371-.004.203-4.16-3.276s.669.68.326.683l3.799 4.134-.256 10.776-6.302-4.963s.946.961.461.966l5.786 6.297-.029 1.242-.035 1.34-.2 8.501 2.043-.022c-.048-2.734-.093-5.598-.138-8.467-.04-2.438-.085-4.881-.12-7.233l-.009-.511 4.519-4.945c-.405.005.367-.813.367-.813Z"
    />
    <path
      fill="#0038FF"
      d="M145.901 161.176c-.656-.524-1.838-.516-2.872-.468.074-.662.351-1.314.431-1.976.08-.662-.071-1.372-.724-1.832-1.134-.799-3.136-.491-4.703-.032.215-1.556-1.439-3.065-3.649-3.305-2.211-.24-4.671.84-5.322 2.353-.894-.855-2.684-1.194-4.173-.79-1.49.404-2.552 1.516-2.477 2.593-1.145-.078-2.42-.131-3.367.363-1.394.728-1.297 2.199-2.37 3.15-.702-.182-1.519.214-1.881.69-.362.476-.425 1.021-.648 1.532-.446 1.024-1.936 1.15-3.355 1.597l35.537.293c.771-.245 1.431-.775 1.399-1.345-.031-.571-.987-1.038-1.729-.751.26.006.667-1.461-.097-2.072Z"
    />
    <path
      fill="#0038FF"
      d="M161.875 162.735c-.402-.322-1.127-.317-1.76-.287.046-.406.215-.806.264-1.212.049-.405-.043-.841-.443-1.122-.695-.49-1.923-.301-2.882-.02.131-.953-.882-1.878-2.237-2.026-1.355-.147-2.862.515-3.262 1.443-.548-.525-1.644-.732-2.558-.485-.913.248-1.563.93-1.517 1.59-.702-.048-1.483-.08-2.064.223-.854.445-.795 1.347-1.453 1.93-.429-.111-.93.131-1.152.423-.222.292-.261.626-.398.939-.273.627-1.186.705-2.056.979l21.78.179c.473-.15.877-.475.858-.824-.019-.35-.605-.636-1.06-.461.159.004.408-.895-.06-1.269Z"
    />
    <g stroke="#222" strokeMiterlimit={10} strokeWidth={0.4}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M73.905 93.636a6.482 6.482 0 0 0-3.693-1.147 6.533 6.533 0 0 0-6.53 6.533v.04a2.279 2.279 0 0 0-1.803-.88c-.626 0-1.193.254-1.608.66a5.138 5.138 0 0 0-10.245.52 1.547 1.547 0 0 0-2.42 1.012h36.348a4.59 4.59 0 0 0-4.592-4.589 4.554 4.554 0 0 0-2.98 1.104 6.546 6.546 0 0 0-.932-1.76M136.368 45.795a7.892 7.892 0 0 1 2.624-.446c4.376 0 7.924 3.552 7.924 7.928v.048a2.766 2.766 0 0 1 2.188-1.068c.76 0 1.448.308 1.952.8a6.236 6.236 0 0 1 12.432.632c.304-.22.676-.344 1.08-.344.936 0 1.712.68 1.856 1.572h-44.108a5.57 5.57 0 0 1 5.572-5.568c1.38 0 2.644.504 3.616 1.34a7.965 7.965 0 0 1 1.927-3.054" />
      </g>
      <path
        fill="#fff"
        d="M1 36.586h44.108a5.57 5.57 0 0 0-5.572-5.568c-1.38 0-2.644.504-3.616 1.34-1.076-3.104-4.016-5.34-7.488-5.34-4.376 0-7.924 3.552-7.924 7.928v.048a2.766 2.766 0 0 0-2.188-1.068c-.76 0-1.448.308-1.952.8a6.236 6.236 0 0 0-12.432.632 1.829 1.829 0 0 0-1.08-.344c-.936 0-1.712.68-1.856 1.572Z"
      />
    </g>
    <g strokeMiterlimit={10} strokeWidth={0.4}>
      <g stroke="#0038FF">
        <path d="m59.784 52.18 1.367 8.549M54.614 55.205l5.69 6.894M53.713 61.057l5.327 2.084" />
      </g>
      <g strokeLinecap="round" strokeLinejoin="round">
        <g stroke="#222">
          <path d="M26.68 75.944v-6.592" />
          <path fill="#fff" d="M11.168 75.944h15.513v-4.858H11.168v4.858Z" />
          <path d="M11.168 75.944v-6.592" />
        </g>
        <path
          fill="#fff"
          stroke="#222"
          d="M65.752 165.073h31.35V110.48h-31.35v54.593Z"
        />
        <path
          fill="#fff"
          stroke="#222"
          d="M34.504 165.073h31.35V90.241h-31.35v74.832ZM3.002 165.073h31.35V75.81H3.002v89.263Z"
        />
        <g stroke="#0038FF">
          <path d="M28.521 81.438v80.253M21.666 81.438v80.253M14.81 81.438v80.253M7.954 81.438v80.253" />
        </g>
        <g stroke="#0038FF">
          <path d="M60.65 94.102v67.347M53.794 94.102v67.347M46.934 94.102v67.347M40.078 94.102v67.347M60.65 94.102H40.077M60.65 101.571H40.077M60.65 109.035H40.077M60.65 116.504H40.077M60.65 123.968H40.077M60.65 131.437H40.077M60.65 138.905H40.077M60.65 146.369H40.077M60.65 153.838H40.077M60.65 161.307H40.077" />
        </g>
        <g stroke="#0038FF">
          <path d="M94.035 114.981H70.337M94.035 122.448H70.337M94.035 129.915H70.337M94.035 137.382H70.337M94.035 144.849H70.337M94.035 152.316H70.337M94.035 159.783H70.337" />
        </g>
      </g>
    </g>
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M166.424 165.306H1"
    />
    <path
      fill="#222"
      d="M55.468 164.842c-.212.1-1.752.156-3.716.188-3.992.068-9.756.036-9.756.036s-.312 0-.432-1.56c-.116-1.56.648-2.8.736-3.452.416-2.992-.62-4.24-.636-4.46 0-.224 5.62-.344 5.62-.344l1.84-.124-.4 2.632c-.024.152-.04.304-.04.452-.076 1.9 1.208 3.632 3.104 4.036l.084.016h.004c.132-.124 2.392-1.172 3.328.276.496.764.264 2.304.264 2.304Z"
    />
    <mask
      id="a"
      width={15}
      height={11}
      x={41}
      y={155}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}
    >
      <path
        fill="#fff"
        d="M55.468 164.842c-.212.1-1.752.156-3.716.188-3.992.068-9.756.036-9.756.036s-.312 0-.432-1.56c-.116-1.56.648-2.8.736-3.452.416-2.992-.62-4.24-.636-4.46 0-.224 5.62-.344 5.62-.344l1.84-.124-.4 2.632c-.024.152-.04.304-.04.452-.076 1.9 1.208 3.632 3.104 4.036l.084.016h.004c.132-.124 2.392-1.172 3.328.276.496.764.264 2.304.264 2.304Z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#fff"
        d="M55.468 164.842c-.212.1-1.752.156-3.716.188-3.992.068-9.756.036-9.756.036s-.312 0-.432-1.56c-.116-1.56.648-2.8.736-3.452.416-2.992-.62-4.24-.636-4.46 0-.224 5.62-.344 5.62-.344l1.84-.124-.4 2.632c-.024.152-.04.304-.04.452-.076 1.9 1.208 3.632 3.104 4.036l.084.016h.004c.132-.124 2.392-1.172 3.328.276.496.764.264 2.304.264 2.304Z"
        opacity={0.2}
      />
    </g>
    <mask
      id="b"
      width={15}
      height={11}
      x={41}
      y={155}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}
    >
      <path
        fill="#fff"
        d="M55.468 164.842c-.212.1-1.752.156-3.716.188-3.992.068-9.756.036-9.756.036s-.312 0-.432-1.56c-.116-1.56.648-2.8.736-3.452.416-2.992-.62-4.24-.636-4.46 0-.224 5.62-.344 5.62-.344l1.84-.124-.4 2.632c-.024.152-.04.304-.04.452-.076 1.9 1.208 3.632 3.104 4.036l.084.016h.004c.132-.124 2.392-1.172 3.328.276.496.764.264 2.304.264 2.304Z"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#000"
        d="M51.752 165.03c-3.992.068-9.756.036-9.756.036s-.312 0-.432-1.56c-.116-1.56.648-2.8.736-3.452.416-2.992-.62-4.24-.636-4.46 0-.224 5.62-.344 5.62-.344l1.84-.124-.4 2.632c-.024.152-.04.304-.04.452-1.268 1.048-2.276 1.892-2.276 1.892s5.12 1.704 5.344 4.928Z"
        opacity={0.3}
      />
    </g>
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M55.468 164.842c-.212.1-1.752.156-3.716.188-3.992.068-9.756.036-9.756.036s-.312 0-.432-1.56c-.116-1.56.648-2.8.736-3.452.416-2.992-.62-4.24-.636-4.46 0-.224 5.62-.344 5.62-.344l1.84-.124-.4 2.632c-.024.152-.04.304-.04.452-.076 1.9 1.208 3.632 3.104 4.036l.084.016h.004c.132-.124 2.392-1.172 3.328.276.496.764.264 2.304.264 2.304Z"
    />
    <path
      fill="#0038FF"
      d="M50.32 151.686c.188 1.004.656 1.288.352 1.76a3.366 3.366 0 0 0-.132.244c-.236.488-.488 1.176-1.416 1.436-1.092.308-6.32.592-7.448.452-1.128-.14-1.768-1.208-1.832-2.096-.068-.884.424-1.456.348-2.46-.076-1-.86-1.296-.912-1.964-.052-.664.596-1.64.588-2.308-.016-1.408.024.128.304-7.876.156-4.564 1.26-5.556 0-10.732-.456-1.868-5.352-35.688-5.352-35.688l15.1.904s.24 5.76.512 12.564c.344 8.656.74 19 .752 21.328.024 4.728-.408 11.352-.756 17.232-.148 2.508-.4 4.236.008 5.192a.904.904 0 0 1 .084.32c.052.656-.392.688-.2 1.692Z"
    />
    <mask
      id="c"
      width={18}
      height={64}
      x={34}
      y={92}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}
    >
      <path
        fill="#fff"
        d="M50.32 151.686c.188 1.004.656 1.288.352 1.76a3.366 3.366 0 0 0-.132.244c-.236.488-.488 1.176-1.416 1.436-1.092.308-6.32.592-7.448.452-1.128-.14-1.768-1.208-1.832-2.096-.068-.884.424-1.456.348-2.46-.076-1-.86-1.296-.912-1.964-.052-.664.596-1.64.588-2.308-.016-1.408.024.128.304-7.876.156-4.564 1.26-5.556 0-10.732-.456-1.868-5.352-35.688-5.352-35.688l15.1.904s.24 5.76.512 12.564c.344 8.656.74 19 .752 21.328.024 4.728-.408 11.352-.756 17.232-.148 2.508-.4 4.236.008 5.192a.904.904 0 0 1 .084.32c.052.656-.392.688-.2 1.692Z"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#000"
        d="M50.54 153.69c-.236.488-.488 1.176-1.416 1.436-1.092.308-6.32.592-7.448.452-1.128-.14-1.768-1.208-1.832-2.096-.068-.884.424-1.456.348-2.46-.076-1-.86-1.296-.912-1.964-.052-.664.596-1.64.588-2.308-.016-1.408.024.128.304-7.876.156-4.564 1.26-5.556 0-10.732-.456-1.868-5.352-35.688-5.352-35.688l15.1.904s.24 5.76.512 12.564c-1.82 7.568-3.932 15.896-4.724 17.296l1.248 2.18s-2.984 6.924-2.984 7.76c0 .832 1.02 8.656 1.356 10.284.332 1.628-1.356.468-1.356 1.836 0 1.256-.136 7.388 6.568 8.412Z"
        opacity={0.3}
      />
    </g>
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M50.32 151.686c.188 1.004.656 1.288.352 1.76a3.366 3.366 0 0 0-.132.244c-.236.488-.488 1.176-1.416 1.436-1.092.308-6.32.592-7.448.452-1.128-.14-1.768-1.208-1.832-2.096-.068-.884.424-1.456.348-2.46-.076-1-.86-1.296-.912-1.964-.052-.664.596-1.64.588-2.308-.016-1.408.024.128.304-7.876.156-4.564 1.26-5.556 0-10.732-.456-1.868-5.352-35.688-5.352-35.688l15.1.904s.24 5.76.512 12.564c.344 8.656.74 19 .752 21.328.024 4.728-.408 11.352-.756 17.232-.148 2.508-.4 4.236.008 5.192a.904.904 0 0 1 .084.32c.052.656-.392.688-.2 1.692Z"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M49.164 104.29s-1.853 1.612-3.43 1.314M48.979 107.314s-3.12-.751-3.476-1.383M44.978 121.564s1.687 4.41 3.559 5.466M48.621 150.769s-3.741 1.157-5.619.313c-1.877-.844 1.468 1.934 4.965 1.688M43.324 130.824s.03 11.696 3.083 14.025"
    />
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
    >
      <path d="M46.459 157.058s1.167-.485 2.264-.476M46.53 158.576s1.083-.384 1.865-.562M46.733 160.027l1.748-.523M47.583 161.214l1.438-.565M49.21 162.234l.837-.642" />
      <path d="M46.82 155.615s-.14 4.014 1.125 5.317c1.265 1.302 2.603 1.342 2.488 1.847" />
    </g>
    <path
      fill="#222"
      d="M35.29 155.145s-5.658.119-5.68.342c-.022.223.8 1.468-.13 4.454-.202.652-1.18 1.889-1.33 3.447-.15 1.557.164 1.556.164 1.556s12.82.072 13.509-.223c0 0 .495-1.536.133-2.298-.72-1.516-3.365-.294-3.282-.276l-.083-.018c-1.972-.436-2.965-2.414-2.294-4.48l.853-2.626-1.86.122Z"
    />
    <mask
      id="d"
      width={15}
      height={10}
      x={28}
      y={155}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}
    >
      <path
        fill="#fff"
        d="M35.29 155.145s-5.658.119-5.68.342c-.022.223.8 1.468-.13 4.454-.202.652-1.18 1.889-1.33 3.447-.15 1.557.164 1.556.164 1.556s12.82.072 13.509-.223c0 0 .495-1.536.133-2.298-.72-1.516-3.365-.294-3.282-.276l-.083-.018c-1.972-.436-2.965-2.414-2.294-4.48l.853-2.626-1.86.122Z"
      />
    </mask>
    <g mask="url(#d)">
      <path
        fill="#fff"
        d="M35.29 155.145s-5.658.119-5.68.342c-.022.223.8 1.468-.13 4.454-.202.652-1.18 1.889-1.33 3.447-.15 1.557.164 1.556.164 1.556s12.82.072 13.509-.223c0 0 .495-1.536.133-2.298-.72-1.516-3.365-.294-3.282-.276l-.083-.018c-1.972-.436-2.965-2.414-2.294-4.48l.853-2.626-1.86.122Z"
        opacity={0.25}
      />
    </g>
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M35.29 155.145s-5.658.119-5.68.342c-.022.223.8 1.468-.13 4.454-.202.652-1.18 1.889-1.33 3.447-.15 1.557.164 1.556.164 1.556s12.82.072 13.509-.223c0 0 .495-1.536.133-2.298-.72-1.516-3.365-.294-3.282-.276l-.083-.018c-1.972-.436-2.965-2.414-2.294-4.48l.853-2.626-1.86.122Z"
    />
    <path
      fill="#0038FF"
      d="m48.565 93.357-14.944-.903s-.919 33.763-.785 35.628c.37 5.169-.902 6.157-1.845 10.715-1.653 7.991-1.43 6.456-1.656 7.863-.107.668-.921 1.639-.985 2.305-.065.666.67.961.574 1.961-.097 1-.687 1.57-.772 2.456-.086.885.37 1.952 1.473 2.091 1.103.139 6.38-.143 7.526-.45 1.147-.307 1.455-1.206 1.837-1.677.382-.471-.033-.756-.052-1.758-.02-1.001.43-1.034.494-1.69a.94.94 0 0 0-.028-.321c-.246-.954.305-2.679.884-5.182 1.356-5.87 2.93-12.484 3.715-17.204.391-2.351 1.803-12.888 2.954-21.587 0 0 1.103-1.783 1.666-5.23"
    />
    <mask
      id="e"
      width={21}
      height={64}
      x={28}
      y={92}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}
    >
      <path
        fill="#fff"
        d="m48.565 93.357-14.944-.903s-.919 33.763-.785 35.628c.37 5.169-.902 6.157-1.845 10.715-1.653 7.991-1.43 6.456-1.656 7.863-.107.668-.921 1.639-.985 2.305-.065.666.67.961.574 1.961-.097 1-.687 1.57-.772 2.456-.086.885.37 1.952 1.473 2.091 1.103.139 6.38-.143 7.526-.45 1.147-.307 1.455-1.206 1.837-1.677.382-.471-.033-.756-.052-1.758-.02-1.001.43-1.034.494-1.69a.94.94 0 0 0-.028-.321c-.246-.954.305-2.679.884-5.182 1.356-5.87 2.93-12.484 3.715-17.204.391-2.351 1.803-12.888 2.954-21.587 0 0 1.103-1.783 1.666-5.23"
      />
    </mask>
    <g mask="url(#e)">
      <path
        fill="#000"
        d="M33.59 93.626c-.002 0-.134 5.044-.134 5.044s3.684.348 7.583 0c4.939-.44 7.94-2.629 7.94-2.629l-.414-2.685s-5.595 1.508-8.357 1.297c-2.762-.212-5.364-.543-6.619-1.027Z"
        opacity={0.3}
      />
    </g>
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="m48.565 93.357-14.944-.903s-.919 33.763-.785 35.628c.37 5.169-.902 6.157-1.845 10.715-1.653 7.991-1.43 6.456-1.656 7.863-.107.668-.921 1.639-.985 2.305-.065.666.67.961.574 1.961-.097 1-.687 1.57-.772 2.456-.086.885.37 1.952 1.473 2.091 1.103.139 6.38-.143 7.526-.45 1.147-.307 1.455-1.206 1.837-1.677.382-.471-.033-.756-.052-1.758-.02-1.001.43-1.034.494-1.69a.94.94 0 0 0-.028-.321c-.246-.954.305-2.679.884-5.182 1.356-5.87 2.93-12.484 3.715-17.204.391-2.351 1.803-12.888 2.954-21.587 0 0 1.103-1.783 1.666-5.23"
    />
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
    >
      <path d="M41.195 134.195s-5.165 8.801-10.267 11.676M30.84 150.769l5.547.702c.413.052.918.212.876.636-.036.367-.468.617-.835.749-1.289.464-2.654.555-3.862.258M31.004 148.104c1.91 1.117 4.17 1.738 6.54 1.797M34.483 132.087s2.807.106 4.242-.022c-1.07 1.466-2.782 2.101-4.474 2.185" />
      <path d="M36.587 96.624s-.412 14.376-.545 20.354c-.132 5.978-.399 12.952-.399 12.952s-.474.718-.25 1.453l.224.734-.123 2.079s-.56.625-.369 1.382c.192.758-1.361 6.024-1.361 6.024l-.27.35c-.565.736-.728 1.652-.424 2.392l-.555 4.51-.007.007c-.625.594-.775 1.483-.352 2.075l-.522 2.349c-.554.537-.688 1.33-.317 1.865l.09.131" />
    </g>
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M62.465 70.127c-.406.874-3.808 3.207-3.808 3.207a2.596 2.596 0 0 1 .24-1.113c.244-.374.417-.736.556-.958a2.327 2.327 0 0 0-.557-1.67c-.462-.513-.83.774-1.03 1.631-.2.858-1.542 2.16-1.481 2.784.113.733.264 1.46.451 2.178 0 0-5.698 2.001-6.328.785a80.382 80.382 0 0 0-4.415-7.5c-1.342 1.87-.284 4.454.473 7.633.757 3.18 3.082 7.622 3.082 7.622 4.17-1.995 8.903-7.215 8.903-7.215s1.113-.495 2.489-.969c1.375-.473 1.175-.874 1.397-2.227.223-1.353 1.376-3.196 1.309-3.897-.067-.703-.874-1.165-1.28-.29Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M48.984 76.882c-.052 2.896.52 12.716 1.14 16.612l-16.966-.428v-.285c1.244-4.609.438-9.579-1.526-13.93-1.04-2.3-1.502-5.243-2.038-8.027-1.364-7.088 2.059-9.28 4.919-9.552 1.104-.052 1.2-.794 2.02-.742.735.044 1.2-.016 1.631-.2.356 1.452 2.328 5.716 3.004 6.204.676.488 1.656.644 2.34.168.68-.476.868-1.384 1.024-2.2.08-.432.188-.888.376-1.284 1 .5 2.744 1.092 4.04 3.424 1.584 5.148.72 1.848 1.952 9.4.188 1.156-1.916.84-1.916.84Z"
    />
    <path
      fill="#0038FF"
      d="m46.31 63.482-1.639-.57c1.114 3.818.151 8.157-2.662 6.444-2.813-1.713-3.928-6.648-4.77-8.809-.441-.136-2.227-.202-3.154.51.968 1.771 3.601 5.295 3.289 8.152-.349 3.196-2.866 6.042-7.566 2.827.641 4.848 2.674 8.344 3.065 9.98 1.43 5.983.475 6.82-.194 12.741 6.793 3.47 15.028 1.745 18.635.69-1.1-6.002-.62-21.2-5.003-31.965Z"
    />
    <mask
      id="f"
      width={23}
      height={37}
      x={29}
      y={60}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}
    >
      <path
        fill="#fff"
        d="m46.31 63.482-1.639-.57c1.114 3.818.151 8.157-2.662 6.444-2.813-1.713-3.928-6.648-4.77-8.809-.441-.136-2.227-.202-3.154.51.968 1.771 3.601 5.295 3.289 8.152-.349 3.196-2.866 6.042-7.566 2.827.641 4.848 2.674 8.344 3.065 9.98 1.43 5.983.475 6.82-.194 12.741 6.793 3.47 15.028 1.745 18.635.69-1.1-6.002-.62-21.2-5.003-31.965Z"
      />
    </mask>
    <g mask="url(#f)">
      <path
        fill="#000"
        d="M35.946 88.945s11.092 4.84 12.675.143a25.821 25.821 0 0 1-8.867.363l-3.808-.506Z"
        opacity={0.3}
      />
    </g>
    <mask
      id="g"
      width={23}
      height={37}
      x={29}
      y={60}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}
    >
      <path
        fill="#fff"
        d="m46.31 63.482-1.639-.57c1.114 3.818.151 8.157-2.662 6.444-2.813-1.713-3.928-6.648-4.77-8.809-.441-.136-2.227-.202-3.154.51.968 1.771 3.601 5.295 3.289 8.152-.349 3.196-2.866 6.042-7.566 2.827.641 4.848 2.674 8.344 3.065 9.98 1.43 5.983.475 6.82-.194 12.741 6.793 3.47 15.028 1.745 18.635.69-1.1-6.002-.62-21.2-5.003-31.965Z"
      />
    </mask>
    <g mask="url(#g)">
      <path
        fill="#000"
        d="m32.018 78.476 8.056-6.403s1.591 4.407-2.686 6.925c-2.9 1.708-5.37-.522-5.37-.522Z"
        opacity={0.3}
      />
    </g>
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="m46.31 63.482-1.639-.57c1.114 3.818.151 8.157-2.662 6.444-2.813-1.713-3.928-6.648-4.77-8.809-.441-.136-2.227-.202-3.154.51.968 1.771 3.601 5.295 3.289 8.152-.349 3.196-2.866 6.042-7.566 2.827.641 4.848 2.674 8.344 3.065 9.98 1.43 5.983.475 6.82-.194 12.741 6.793 3.47 15.028 1.745 18.635.69-1.1-6.002-.62-21.2-5.003-31.965Z"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M48.621 88.93c-.107.606-.576 1.103-1.125 1.384M45.708 90.745a17.513 17.513 0 0 1-9.761-1.95"
    />
    <path
      fill="#222"
      d="m61.25 63.637-3.458 9.26c-.126.334-.089.712.1 1.012l.644 1.033c.315.508 1.43.661 1.912.33.168-.115.3-.28.382-.474l3.425-9.253a1.15 1.15 0 0 0-.247-1.262l-1.081-1.043a1.003 1.003 0 0 0-1.471.054 1.11 1.11 0 0 0-.205.343Z"
    />
    <path
      fill="#fff"
      d="M29.8 66.13s0 1.676.982 4.01c1.67 3.97 8.036 13.847 9.433 14.514 1.397.668 15.665-7.012 16.696-8.066 1.03-1.053.455-2.45.455-2.45s-.017.985.821.803c.53-.115.091-1.746.091-1.746s.968-.684.048-1.95c0 0 1.303 0 1.214-.982-.036-.393-3.876-.453-4.465.653-.717 1.346-1.426 4.85-1.426 4.85s-9.299 2.4-11.224 2.757L37.36 67.48"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M29.8 66.13s0 1.676.982 4.01c1.67 3.97 8.036 13.847 9.433 14.514 1.397.668 15.665-7.012 16.696-8.066 1.03-1.053.455-2.45.455-2.45s-.017.985.821.803c.53-.115.091-1.746.091-1.746s.968-.684.048-1.95c0 0 1.303 0 1.214-.982-.036-.393-3.876-.453-4.465.653-.717 1.346-1.426 4.85-1.426 4.85s-9.299 2.4-11.224 2.757L37.36 67.48"
    />
    <path
      fill="#fff"
      d="M57.059 77.176a3.937 3.937 0 0 1 1.436-1.804c.753-.36 1.79-.468 2.608-.627 0 0 .641-2.709.989-2.636 1.061.222.234 2.712.234 2.712"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M57.059 77.176a3.937 3.937 0 0 1 1.436-1.804c.753-.36 1.79-.468 2.608-.627 0 0 .641-2.709.989-2.636 1.061.222.234 2.712.234 2.712"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M63.6 71.135a.774.774 0 0 0-1.046-.045c-.512.468-1.297 1.793-2.132 2.5M56.187 73.984c.227-.505 1.85-1.358 2.17-.264M56.164 72.65s1.877-1.024 2.253.244M56.415 71.427s.783-.151.952-.168c.623-.062 1.298-.14 1.632-.14"
    />
    <path
      fill="#0038FF"
      d="M46.955 105.604s-2.498-2.205-3.953-2.627l3.953 2.627Z"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M46.955 105.604s-2.498-2.205-3.953-2.627"
    />
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
    >
      <path d="M34.334 157.082s1.209-.493 2.306-.484M34.274 158.625s1.117-.39 1.914-.571M34.352 160.1l1.794-.532M35.1 161.307l1.487-.575M36.64 162.344l.892-.653" />
      <path d="M34.82 155.615s-.486 4.081.667 5.405c1.153 1.324 2.487 1.364 2.328 1.878" />
    </g>
    <path
      fill="#222"
      d="M44.517 62.745s1.687 6.582-1.022 7.081c-3.69.68-6.256-9.282-6.256-9.282.566-.039.632-.273 1.123-.555 0 0 4.127 8.233 6.155 2.756ZM33.29 61.496s-3.86.768-3.876 6.506c-.014 5.696 2.532 10.522 2.532 10.522s3.016-.246 4.92-1.64c3.991-2.923 3.35-4.562 3.35-4.562l-2.096-4.153s-.686-2.658-3.679-6.897l-1.151.224ZM46.549 63.71c2.102 5.974 2.197 8.208 2.577 10.964 0 0 2.062-.414 2.377-.856 0 0-1-4.887-2.08-7.415-.685-1.603-1.592-2.17-2.874-2.693Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M44.512 56.93s-.302 5.471-.28 5.91c.035.83.635 1.93.082 2.549-.556.62-1.546.693-2.316.373-.77-.32-1.358-.954-1.888-1.598a21.196 21.196 0 0 1-2.458-3.752c.192-.144.72-.77.978-1.6 0 0 .104-.463.111-.485.16-1.102.101-2.293-.047-3.392-.295-2.227-.963-4.088-.963-4.088l6.781 6.083Z"
    />
    <path
      fill="#222"
      d="M38.825 62.154c1.177.401 2.032.781 2.742 1.168l-2.742-1.168Z"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M38.825 62.154c1.177.401 2.032.781 2.742 1.168"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M37.986 43.694s-3.407 1.948-1.64 7.033c1.766 5.085 5.692 10.763 9.257 10.003 3.565-.761 4.49-7.843 2.603-12.563-1.887-4.72-6.682-7.338-10.22-4.473Z"
    />
    <path
      fill="#222"
      d="M48.152 53.077c.025.419-.14.77-.363.784-.223.013-.428-.317-.453-.735-.025-.42.134-.765.363-.779.229-.014.428.31.453.73ZM44.675 52.914c.025.413-.133.765-.357.778-.223.013-.428-.316-.453-.73-.024-.413.134-.77.363-.783.229-.014.422.31.447.735Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M45.984 44.569c-2.284-2.222-5.394-2.911-7.878-.898 0 0-3.407 1.949-1.64 7.034a25.643 25.643 0 0 0 1.546 3.528l.065.056s-1.12-1.116 3.323-3.57c1.458-.827 3.616-5.964 4.584-6.15Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M42.416 46.227s.314-3.542 2.776-3.663c1.284-.063 2.981 1.66 3.192 2.57.29 1.258 1.275 2.237 2.542 2.48 0 0-.714 2.405-2.103 2.575-2.292.281-3.479-.255-4.957-2.276-.424-.58-.876-1.138-1.394-1.633l-.056-.053Z"
    />
    <path
      fill="#fff"
      d="M38.746 53.034s-1.348-2.777-2.547.282c-.746 1.902 2.243 3.424 3.268 2.922"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M38.746 53.034s-1.348-2.777-2.547.282c-.746 1.902 2.243 3.424 3.268 2.922M46.77 51.355a2.126 2.126 0 0 0-.5 1.878c.102.727.347 1.426.72 2.058l-1.709.556M43.76 57.09a2.02 2.02 0 0 0 2.095.464M41.863 51.308s1.192-1.329 2.648-.69M47.434 50.952s1.57-.488 1.371.897"
    />
    <path
      fill="#222"
      d="M38.72 54.558c-.274.047-.524-.184-.64-.437-.117-.253-.149-.539-.266-.791-.117-.253-.368-.484-.642-.436"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M38.72 54.558c-.274.047-.524-.184-.64-.437-.117-.253-.149-.539-.266-.791-.117-.253-.368-.484-.642-.436"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M43.709 43.586a7.903 7.903 0 0 0-.82-2.042c.002.014.651-.167 1.01-.243l-.19 2.285Z"
    />
    <path
      fill="#222"
      d="m44.394 60.573.026 1.212c-.218.104-.494.152-.84.112-1.536-.177-3.086-3.582-3.18-3.794-.002-.004-.005-.004-.006-.007.014.009.024.023.034.033 1.822 2 3.167 2.431 3.966 2.444Z"
    />
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
    >
      <path d="M96.283 72.086h10.108M84.687 72.086h10.266M79.221 72.086h3.155M87.521 77.575h18.83M82.376 77.575h2.311M95.95 83.064h10.361M85.532 83.064h8.883M94.528 88.553h11.743M88.687 88.553h4.175" />
      <g strokeMiterlimit={10}>
        <path
          fill="#fff"
          d="M129.062 88.754h-29.43l1.477-16.874h29.43l-1.477 16.874Z"
        />
        <path d="M130.539 71.88h-29.43" />
        <path
          fill="#fff"
          d="M129.063 88.753H99.632l10.06-9.552 5.112 4.358 5.982-4.44 8.277 9.634Z"
        />
        <path
          fill="#fff"
          d="m130.539 71.88-9.753 7.238-5.982 4.44-5.112-4.357-8.584-7.321h29.431Z"
        />
      </g>
      <path d="M76.404 72.086h-7.388" />
    </g>
    <path
      fill="#fff"
      d="M104.713 52.755c-5.9 4.81-16.781 7.73-16.781 7.73l5.485-5.876v-.004c-5.04-1.623-8.688-6.352-8.688-11.935 0-7.22 6.105-13.015 13.434-12.505 6.274.437 11.314 5.59 11.623 11.87a12.514 12.514 0 0 1-4.992 10.659"
    />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M104.713 52.755c-5.9 4.81-16.781 7.73-16.781 7.73l5.485-5.876v-.004c-5.04-1.623-8.688-6.352-8.688-11.935 0-7.22 6.105-13.015 13.434-12.505 6.274.437 11.314 5.59 11.623 11.87a12.514 12.514 0 0 1-4.992 10.659"
    />
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
    >
      <path
        fill="#0038FF"
        d="M105.012 37.266a3.692 3.692 0 1 0 0-7.384 3.692 3.692 0 0 0 0 7.384Z"
      />
      <path
        fill="#222"
        d="m102.872 32.752 2.14 2.407 4.867-5.76-.17-.181-4.697 4.04-1.244-1.355-.896.849Z"
      />
    </g>
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
    >
      <path d="M90.773 39.633h13.785M90.462 43.192h13.785M90.15 46.752h13.786" />
    </g>
    <g
      fill="#0038FF"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.4}
    >
      <path d="M133.571 8.22v6.31l17.268-13.31-17.268 7ZM133.571 8.22 151.237 1l-24.12 2.502 6.454 4.718Z" />
      <path d="m135.648 9.526 8.318 6.154L151.237 1l-15.589 8.526Z" />
      <path d="m135.648 9.526-2.077 5.004 4.424-3.268-2.347-1.736Z" />
    </g>
    <g
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
    >
      <path d="m67.4 62.425.136-.377" />
      <path
        strokeDasharray="0.8 1.6"
        d="M68.06 60.538c3.72-11.11 3.052-17.784 9.09-28.546 1.22-2.175 7.277-12.47 15.912-16.141 4.487-1.908 7.344.94 6.188 2.953-2.58 4.492-12.056-.89-2.58-6.202 8.765-4.913 27.43 4.691 36.179 1.936"
      />
      <path d="M133.598 14.262c.123-.053.244-.11.362-.169" />
    </g>
  </svg>
)
